
<svg :width="width" :height="height" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M47 57V55H57V57H47Z" fill="#FF0064" />
  <path
    d="M43 56C43 57.1046 42.1046 58 41 58C39.8954 58 39 57.1046 39 56C39 54.8954 39.8954 54 41 54C42.1046 54 43 54.8954 43 56Z"
    fill="#FF0064"
  />
  <path d="M47 62V60H57V62H47Z" fill="#FF0064" />
  <path
    d="M43 61C43 62.1046 42.1046 63 41 63C39.8954 63 39 62.1046 39 61C39 59.8954 39.8954 59 41 59C42.1046 59 43 59.8954 43 61Z"
    fill="#FF0064"
  />
  <path d="M47 67V65H57V67H47Z" fill="#FF0064" />
  <path
    d="M43 66C43 67.1046 42.1046 68 41 68C39.8954 68 39 67.1046 39 66C39 64.8954 39.8954 64 41 64C42.1046 64 43 64.8954 43 66Z"
    fill="#FF0064"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19.4494 33.27L18.487 33.5414C15.7557 34.3115 14.1232 35.8749 13.4142 38.2416C13.2473 38.7989 13.0993 39.843 12.9982 41.4517L12.9355 42.4498L10.9395 42.3243L11.0022 41.3263C11.1038 39.7092 11.2599 38.4637 11.4984 37.6677C12.4262 34.5705 14.6332 32.55 17.9442 31.6165L18.9067 31.3451L19.4494 33.27ZM26.7897 31.2867L27.7581 31.5361C31.116 32.4009 33.3989 34.3416 34.4097 37.3757C34.6932 38.2265 34.8778 39.5714 34.9979 41.3205L35.0663 42.3182L33.071 42.4552L33.0025 41.4575C32.883 39.7156 32.7081 38.5956 32.5123 38.0078C31.7475 35.7122 30.0622 34.1948 27.2593 33.4729L26.2909 33.2235L26.7897 31.2867Z"
    fill="#05070F"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M23 23C20.2386 23 18 25.2386 18 28C18 30.7614 20.2386 33 23 33C25.7614 33 28 30.7614 28 28C28 25.2386 25.7614 23 23 23ZM16 28C16 24.134 19.134 21 23 21C26.866 21 30 24.134 30 28C30 31.866 26.866 35 23 35C19.134 35 16 31.866 16 28Z"
    fill="#05070F"
  />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M33 19H13V43H33V19ZM11 17V45H35V17H11Z" fill="#05070F" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 10C5.34315 10 4 11.3431 4 13V72H2V13C2 10.2386 4.23858 8 7 8H73C75.7614 8 78 10.2386 78 13V72H76V13C76 11.3431 74.6569 10 73 10H7Z"
    fill="#05070F"
  />
  <path d="M39 22V18H69V22H39Z" fill="#05070F" />
  <path d="M39 27V25H57V27H39Z" fill="#05070F" />
  <path d="M39 32V30H61V32H39Z" fill="#05070F" />
  <path d="M39 42V40H59V42H39Z" fill="#05070F" />
  <path d="M39 51V49H63V51H39Z" fill="#05070F" />
  <path d="M39 37V35H55V37H39Z" fill="#05070F" />
  <path d="M11 56V54H31V56H11Z" fill="#05070F" />
  <path d="M11 51V49H27V51H11Z" fill="#05070F" />
  <path d="M11 61V59H27V61H11Z" fill="#05070F" />
</svg>
